import { useContext } from 'react';
import { LoaderContext } from '../../../shared/context/loaderContext';
import { NotificationContext } from '../../../shared/context/notificationContext';
import { useCm360Api } from '../../../shared/const/api-backend';
import { reportError } from 'shared/services/raygunService';

const useAddNote = () => {
  const { setLoading } = useContext(LoaderContext);
  const { showNotification } = useContext(NotificationContext);
  const API = useCm360Api();

  const addNote = async (bookingId, content) => {
    setLoading(true);
    try {
      const apiUrl = `/booking/${bookingId}/notes`;
      await API.post(apiUrl, { content });
      showNotification('Note added successfully', 'success');
    } catch (error) {
      showNotification('Error adding note', 'error');
      reportError(error);
    } finally {
      setLoading(false);
    }
  };

  return { addNote };
};

export default useAddNote;
